export const IS_TEST_MODE = !!window.Cypress;
